import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=5865113c&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "../assets/login.css?vue&type=style&index=0&id=5865113c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865113c",
  null
  
)

export default component.exports